import React, {Component} from 'react';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import DateSinceFilter from '../components/DateSinceFilter';
import ListButton from '../buttons/ListButton';
import TransferListTable from '../components/TransferListTable';
import {viewStyles} from '../shared/styles-view';
import {Card, CardActions, CardText} from 'material-ui/Card';
import Avatar from 'material-ui/Avatar';
import CircularProgress from 'material-ui/CircularProgress';
import Icon from 'material-ui/svg-icons/action/assignment-turned-in';

export class ReceivedTransferList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listComplete: false,
            loading: false,
            startDate: null,
            startDateStr: ''
        };
    }

    handleFilterSubmit = (value) => {
        if (value) {
            const date = new Date(value);
            const str = date.getUTCMonth() + 1 + '/' + date.getUTCDate() + '/' + date.getUTCFullYear();
            this.setState({
                listComplete: false,
                loading: true,
                startDate: value,
                startDateStr: str
            });
        }
    };

    handleListComplete = (isComplete) => {
        this.setState({
            listComplete: isComplete,
            loading: false
        });
    };

    render() {
        const {
            listComplete,
            loading,
            startDate,
            startDateStr
        } = this.state;

        const ListTitle = <span className="list-title">
            <Avatar icon={<Icon/>} className="avatar-title"/>Received Transfers</span>;

        const ListDescription = () => {
            return (
                <span>
                    <p>View transfers received at all Locations since a specified date. These represent
                        Products that have arrived, displaying Locations and States they were transferred
                        from and to, the date they were created, and a unique transfer ID.</p>
                    <p>Click a transfer's <strong>View</strong> icon to view its contents. A transfer may
                        contain Product Units, Repacks, or Retail Boxes.</p>
                </span>
            );
        };

        return (
            <div className="list-container">
                <Card>
                    <CardActions style={viewStyles.actions}>
                        <ListButton basePath="/InventoryTransfers" label="List Incoming Transfers"/>
                        <ListButton basePath="/InventoryTransfersByMemo" label="List Transfers by Memo"/>
                    </CardActions>

                    <ViewTitle title={ListTitle}/>

                    <CardText>
                        <ListDescription/>

                        <DateSinceFilter
                            labelInput="Select Date Since"
                            labelSubmit="Search Transfers"
                            loading={loading}
                            onSubmitDate={this.handleFilterSubmit}
                        />

                        {startDate &&
                        <div>
                            <h3>
                                Transfers received since {startDateStr}
                            </h3>

                            {!listComplete &&
                            <div className="loader-container">
                                <h4>Retrieving Transfers...</h4>
                                <CircularProgress
                                    size={24}
                                    thickness={2}
                                    className="loader"
                                />
                            </div>
                            }

                            {/* Transfer Table */}
                            <TransferListTable
                                basePath="InventoryTransfers"
                                transferType="received"
                                startDate={startDate}
                                listComplete={listComplete}
                                onDataComplete={this.handleListComplete}
                            />
                        </div>
                        }
                    </CardText>
                </Card>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/Inventory/ReceivedTransferList.js